import { Alert, AlertDescription } from '@/components/ui/alert';
import { formatRatio } from '@/lib/format';
import { ProjectionForm } from '@/features/simulations/ProjectionForm';
import { SavedSimulations } from '@/features/simulations/SavedSimulations';
import { SimulateurTabs } from '@/features/simulations/SimulateurTabs';
import { computeProjection, engineOf } from '@/features/simulations/engine';
import { useAssumptions } from '@/features/simulations/queries';

export function SimulateurProjectionPage() {
  const assumptions = useAssumptions();

  return (
    <div className="flex flex-col gap-6">
      <h1 className="text-2xl font-semibold">Simulateur</h1>
      <SimulateurTabs />
      <Alert>
        <AlertDescription>
          Modèle indicatif, à faire valider par votre comptable. Les hypothèses globales
          (inflation, amortissement du bâti…) viennent de la dernière version enregistrée.
        </AlertDescription>
      </Alert>

      {assumptions.isPending && <p className="text-muted-foreground">Chargement…</p>}
      {assumptions.isError && (
        <p className="text-destructive">
          Aucune hypothèse globale enregistrée : elle doit être saisie avant de projeter un bien.
        </p>
      )}

      {assumptions.data && (
        <>
          <ProjectionForm assumptions={assumptions.data} />
          <SavedSimulations
            kind="projection"
            renderHeadline={(simulation) => {
              try {
                const projection = computeProjection(simulation.input, assumptions.data, engineOf(simulation.engineVersion));
                return <span>TRI : {formatRatio(projection.kpi.irr)}</span>;
              } catch {
                return <span className="text-muted-foreground">Non calculable</span>;
              }
            }}
          />
        </>
      )}
    </div>
  );
}
